export default "__VITE_ASSET__7bYdZcS$__"